import React, { ReactElement, useMemo } from 'react';
import { Typography, Button } from '@mui/material';
import { trackEvent } from '@surfline/web-common';
import theme from '@wavetrak/theme';

import Information from 'components/Information';
import config from 'config';

import styles from './InformationPaywall.module.scss';

const UPGRADE_URL = `${config.surflineHost}/upgrade`;

interface SegmentProperties {
  location: string;
  spotId?: string;
  spotName?: string;
  subregionId?: string;
  subregionName?: string;
  modalType: string;
  uiElement: string;
}

const DialogFooter: React.FC<{ segmentProps: SegmentProperties }> = ({ segmentProps }) => {
  const segmentPropsFooterCTA = useMemo(
    () => ({
      location: segmentProps.location,
      spotId: segmentProps.spotId,
      spotName: segmentProps.spotName,
      subregionId: segmentProps.subregionId,
    }),
    [segmentProps],
  );

  const onClickHandler = () => {
    trackEvent('Clicked Subscribe CTA', segmentPropsFooterCTA);
  };

  return (
    <div className={styles.dialogFooter}>
      <Button
        aria-label="paywall link"
        data-testid="paywall-link"
        disableFocusRipple
        disableRipple
        disableTouchRipple
        href={UPGRADE_URL}
        onClick={onClickHandler}
        variant="primary"
      >
        <Typography
          className={styles.footerButtonText}
          color={theme.expressive.marineLayer}
          variant="callout1"
        >
          Go Premium
        </Typography>
      </Button>
    </div>
  );
};

interface InformationPaywallProps {
  articleId: string;
  children?: ReactElement;
  className?: string;
  segmentProps: SegmentProperties;
}

const InformationPaywall: React.FC<InformationPaywallProps> = ({
  articleId,
  children,
  className,
  segmentProps,
}) => {
  const segmentPropsInformation = useMemo(
    () => ({
      modalType: segmentProps.modalType,
      spotId: segmentProps.spotId,
      spotName: segmentProps.spotName,
      subregionId: segmentProps.subregionId,
      uiElement: segmentProps.uiElement,
      subregionName: segmentProps.subregionName,
    }),
    [segmentProps],
  );

  return (
    <Information
      DialogFooter={<DialogFooter segmentProps={segmentProps} />}
      articleId={articleId}
      className={className}
      dialogClassName={styles.dialogWrapper}
      segmentProps={segmentPropsInformation}
      tooltip={undefined}
    >
      {children}
    </Information>
  );
};

export default InformationPaywall;
